









































import { Component, Mixins } from 'vue-property-decorator';
import GlobalMixins from '@/plugins/mixins';
import { User } from '@/interface/user';
import { Github } from '@/plugins/github';
import { Imgs } from '@/types/';

declare global {
	interface Window {
		monaco: any;
	}
}

@Component({
	watch: {
		$route(to, from) {
			this.$logger.info('route', `Change route ${from.path} to ${to.path}.`);

			if ( !this.$store.getters.user ) {
				if ( to.path.replace(/^\/../, '') ) {
					const t = this as any;
					t.$assign('/');
					return;
				}
			}

			if ( to.params.lang ) {
				if ( this.$vuetify.lang.current !== to.params.lang ) {
					this.$vuetify.lang.current = to.params.lang;
				}
			}
		},
	},
})
export default class App extends Mixins(GlobalMixins) {

	public imgs: Imgs = {
		oops: require('assets/oops.png'),
	};

	public created() {
		this.$logger.debug('app', 'App created');
		this.$git.progress((event: string, ...args: any[]) => {
			this.$store.commit('loadmsg',
				this.$t(`github.progress.${event}`, ...args));
		});

		this.$store.watch(() => this.$store.getters.user, async (u: User) => {
			this.$git.setUser(u);
			await this.$git.initRepo(`${u.userName}.github.io`);
			this.$logger.debug('github', 'Octokit login', this.$git);
		});

		const user = this.$session.read<User>('userInfo', JSON.parse);
		if ( user ) {
			this.$logger.info('app', 'Has login user info.', user);
			this.$store.commit('setUser', user);
			window.addEventListener('load', () => {
				this.$logger.info('router', 'Now router', this.$route);
				if ( this.$route.path.match(/^\/..$/) ) {
					this.$assign('/dashboard');
				}
			});
		}
	}

}
